var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNegativeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.075 9.55718V1.35718C5.075 1.07384 5.17083 0.836344 5.3625 0.644678C5.55417 0.453011 5.79167 0.357178 6.075 0.357178C6.35833 0.357178 6.59583 0.453011 6.7875 0.644678C6.97917 0.836344 7.075 1.07384 7.075 1.35718V9.55718L9.975 6.65718C10.1583 6.47384 10.3917 6.38218 10.675 6.38218C10.9583 6.38218 11.1917 6.47384 11.375 6.65718C11.5583 6.84051 11.65 7.07384 11.65 7.35718C11.65 7.64051 11.5583 7.87384 11.375 8.05718L6.775 12.6572C6.575 12.8572 6.34167 12.9572 6.075 12.9572C5.80833 12.9572 5.575 12.8572 5.375 12.6572L0.775 8.05718C0.591667 7.87384 0.5 7.64051 0.5 7.35718C0.5 7.07384 0.591667 6.84051 0.775 6.65718C0.958333 6.47384 1.19167 6.38218 1.475 6.38218C1.75833 6.38218 1.99167 6.47384 2.175 6.65718L5.075 9.55718Z",
    fill: "#F85050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNegativeRed);
export default __webpack_public_path__ + "static/media/arrow_negative_red.99d76ec2827ba41b90ac799d91a73f68.svg";
export { ForwardRef as ReactComponent };